import { PureComponent } from 'react';

import { FormControl, type IFormikFormControlProps } from './FormControl'
import { AsyncSelect, type IAsyncSelectProps } from '../../elements/Select/'

export interface IFormAsyncSelectProps<OptionType>
  extends Pick<
      IFormikFormControlProps,
      Exclude<keyof IFormikFormControlProps, 'children'>
    >,
    IAsyncSelectProps<OptionType> {
  id: string
  name: string
}

export class FormAsyncSelect<OptionType> extends PureComponent<
  IFormAsyncSelectProps<OptionType>
> {
  static defaultProps = {
    fullWidth: true,
  }

  render() {
    const {
      name,
      disabled,
      id,
      label,
      helperText,
      required,
      fullWidth,
      ...AsyncSelectProps
    } = this.props

    const inputId = `${id}-input`

    return (
      <FormControl
        name={name}
        disabled={disabled}
        id={id}
        label={label}
        helperText={helperText}
        required={required}
        fullWidth={fullWidth}
        labelFor={inputId}
      >
        {({ value, handleChange, handleBlur, isSubmitting, error }) => (
          <AsyncSelect<OptionType>
            id={id}
            inputId={inputId}
            name={name}
            isDisabled={isSubmitting || disabled}
            onChange={handleChange}
            onBlur={handleBlur}
            value={value}
            error={error}
            {...AsyncSelectProps}
          />
        )}
      </FormControl>
    )
  }
}
